import { useEffect, useState } from 'react';
import { BusinessUnit } from '../types/commonTypes';
import { paginateAll } from '../../shared/paginationHelper';
import { getAppHostConfig } from '@amzn/et-console-components';

const { WEB_HOST_AND_PORT } = getAppHostConfig();

interface State {
  isLoadingBusinessUnits: boolean;
  businessUnits: BusinessUnit[];
  businessUnitsById: { [id: number]: BusinessUnit };
}

// TODO: Needs to reload when the user profile changes
export const useBusinessUnits = (): State => {
  const [state, setState] = useState<State>({
    isLoadingBusinessUnits: true,
    businessUnits: [],
    businessUnitsById: {},
  });
  useEffect(() => {
    const paginate = async (): Promise<void> => {
      const result = await paginateAll(`//${WEB_HOST_AND_PORT}/web/api/v9/businessUnit/list`);

      setState({
        isLoadingBusinessUnits: false,
        businessUnits: result,
        businessUnitsById: result.reduce((acc, val) => {
          acc[val.id] = val;
          return acc;
        }, {}),
      });
    };

    paginate();
  }, []);

  return state;
};
